import { useDispatch } from "react-redux";
import TitleValueWidget from "../../../../components/trade_value_widget/TitleValueWidget";
import { Button, PanelSlider } from "../../../../components/ui";
import { setCurrentSteps, setPayoutClick, setTableClick } from "../bloc/beneficiariesSlice";
import Steps from "../../../../components/steps";
import PayoutsData from "../payout/payouts-data";
import cancelIcon from "../../../../assets/images/close.svg";
import BenPayoutOtpVerification from "../ben-otp-verification";
import useBenficiaryOtpVerification from "../ben-otp-verification/useBenPayoutOtpVerication";
import useBeneficiaryActById from "./useBenificiaryAccbyId";
import copyIcon from "../../../../assets/images/copy.svg";
import { copyText } from "../../../../helpers/payouts";
import { resetPayouts } from "../payout/payoutSlice";

const SelectedBeneficiary = () => {
  const dispatch = useDispatch();
  const { sendOtpApiCall, benPayoutOtp, refId } = useBenficiaryOtpVerification({});
  const {
    selectedBeneficiary,
    payoutClick,
    currentSteps,
    onClickSubmitStatusChange,
    roleType
  } = useBeneficiaryActById();

  return (
    <>
      <div className="card_space_18" style={{ height: "calc(-8rem + 100vh)" }}>
        {(roleType === 'ADMIN' || roleType === 'MANAGER') && (
          <div className="flex justify-end items-center gap-4">
            <Button
              variant="outlined-primary"
              onClick={() => {
                sendOtpApiCall("TP_BEN");
              }}
              disabled={benPayoutOtp > 0}
            >
              {selectedBeneficiary?.status === 1
                ? "Mark as Inactive"
                : "Mark as Active"}
            </Button>

            {selectedBeneficiary?.status === 1 && (
              <Button
                variant="outlined-primary"
                onClick={() => {
                  dispatch(setPayoutClick(true));
                  dispatch(setCurrentSteps(1));
                  dispatch(resetPayouts());
                }}
                disabled={benPayoutOtp > 0}
              >
                Payout
              </Button>
            )}
          </div>
        )}

        <div className="w-full bg-white rounded-lg card_space_18 space_18">
          <div className="grid grid-cols-3 w-full gap-4">
            <div className="flex gap-2">
              <TitleValueWidget
                title="Fund Account ID"
                value={selectedBeneficiary?.rzpFa || "-"}
              />

              <img
                src={copyIcon}
                className="cursor-pointer w-6 h-6"
                onClick={(e) => {
                  e.stopPropagation();
                  copyText(String(selectedBeneficiary?.rzpFa));
                }}
              />
            </div>

            <TitleValueWidget
              title="Account Holder"
              value={selectedBeneficiary?.actHolder || "-"}
            />

            <TitleValueWidget
              title="Account Number"
              value={selectedBeneficiary?.actNum || "-"}
            />
          </div>

          <div className="grid grid-cols-3 w-full gap-4 space_18">
            <TitleValueWidget
              title="Bank Name"
              value={selectedBeneficiary?.bank || "-"}
            />

            <TitleValueWidget
              title="IFSC Code"
              value={selectedBeneficiary?.ifsc || "-"}
            />

            <TitleValueWidget
              title="Account Type"
              value={selectedBeneficiary?.accntType || "-"}
            />
          </div>

          <div className="grid grid-cols-3 w-full gap-4 space_18">
            <TitleValueWidget
              title="Party type"
              value={selectedBeneficiary?.userType || "-"}
            />

            <TitleValueWidget
              title="Contact Number"
              value={selectedBeneficiary?.mobile || "-"}
            />

            <TitleValueWidget
              title="Email Address"
              value={selectedBeneficiary?.email || "-"}
            />
          </div>

          <div className="w-full space_18">
            <TitleValueWidget title="Note 1" value={selectedBeneficiary?.notes?.split('#')[0] || '-'} />
          </div>

          <div className="w-full space_18">
            <TitleValueWidget title="Note 2" value={selectedBeneficiary?.notes?.split('#')[1] || '-'} />
          </div>
        </div>
        {benPayoutOtp ? <BenPayoutOtpVerification type="TP_BEN" /> : ""}
      </div>
      <div className="bg-white flex absolute bottom-0 justify-between items-center gap-10 px-6 py-4 w-full border-t">
        <Button
          className="w-[100px]"
          onClick={() => {
            dispatch(setTableClick(false));
          }}
          variant="transparent"
        >
          Cancel
        </Button>

        <Button
          className="w-[100px]"
          onClick={() => {
            onClickSubmitStatusChange();
          }}
          variant="contained"
          disabled={!refId}
        >
          Submit
        </Button>
      </div>
      {payoutClick && (
        <PanelSlider
          direction="right_to_left"
          open={payoutClick}
          onClose={() => {
            dispatch(setPayoutClick(false));
          }}
          style={{ width: "40vw" }}
        >
          <div
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
            className="panel-content"
          >
            <div className="border-b card_space_18 flex items-center justify-between">
              <div>
                <h2 className="fs-14 font-bold">Payout</h2>
              </div>
              <div>
                <Steps stepCount={2} currentStep={currentSteps} />
              </div>
              <div>
                <img
                  src={cancelIcon}
                  alt=""
                  className="cursor-pointer"
                  onClick={() => {
                    dispatch(setPayoutClick(false));
                  }}
                />
              </div>
            </div>

            <PayoutsData />
          </div>
        </PanelSlider>
      )}
    </>
  );
};
export default SelectedBeneficiary;
